import { Reset, Theme } from "@bluframe/blublocks"
import Button from "components/buttons/Button"
import Select from "components/inputs/Select"
import Typography from "components/Typography"
import { rgba } from "polished"
import styled from "styled-components"
import mediaQueries from "styles/mediaQueries"

const HANDLE_ROW_BORDER_ALPHA = 0.12

export const Wrapper = styled.div`
  align-items: start;
  background-color: ${({ theme }: { theme: Theme }) =>
    theme.palette.text.contrast};
  display: grid;
  padding: 20px;
  row-gap: 16px;
  width: 100%;
`

export const Header = styled.div`
  align-items: start;
  display: grid;
  grid-template-columns: 1fr auto;
`

export const Title = styled.div`
  display: grid;
  row-gap: 6px;
`

export const SectionTitle = styled(Typography.H4)`
  margin: 0;
`

export const ErrorBanner = styled.div`
  align-items: center;
  background: ${({ theme }: { theme: Theme }) => theme.palette.error.main};
  border-radius: 8px;
  color: ${({ theme }: { theme: Theme }) => theme.palette.error.contrast};
  column-gap: 16px;
  display: grid;
  grid-template-columns: 1fr auto;
  padding: 12px 14px;

  p {
    color: ${({ theme }: { theme: Theme }) => theme.palette.error.contrast};
    margin: 0;
  }
`

export const Filters = styled.div`
  display: grid;
  row-gap: 12px;
`

export const FiltersGrid = styled.div`
  column-gap: 12px;
  display: grid;
  row-gap: 12px;

  & > * {
    width: 100%;
  }

  ${mediaQueries.tablet} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

export const FiltersActions = styled.div`
  display: grid;
  justify-content: start;
`

export const FiltersSelect = styled(Select)`
  margin-top: 20px;
`

export const FiltersToggleButton = styled(Button)`
  color: ${({ theme }: { theme: Theme }) => theme.palette.text.main};
  grid-template-columns: 1fr auto;
  justify-content: start;
  justify-items: start;
  text-align: left;

  &:hover,
  &:focus-visible {
    color: ${({ theme }: { theme: Theme }) => theme.palette.text.main};
  }

  & > span:first-child {
    display: none;
  }

  & > :last-child {
    justify-self: end;
  }
`

export const Content = styled.div`
  align-items: start;
  column-gap: 16px;
  display: grid;
  row-gap: 16px;

  ${mediaQueries.desktop} {
    grid-template-columns: minmax(0, 1fr) minmax(0, 420px);
  }
`

export const Handles = styled.div`
  display: grid;
  padding: 14px;
  row-gap: 12px;
`

export const ProspectsUl = styled(Reset.Ul)`
  display: grid;
  row-gap: 10px;
`

export const ProspectsLi = styled(Reset.Li)``

export const HandleRow = styled(Button)<{ $isSelected: boolean }>`
  align-items: start;
  background: ${({
    $isSelected,
    theme
  }: {
    $isSelected: boolean
    theme: Theme
  }) =>
    $isSelected ? theme.palette.secondary.main : theme.palette.text.contrast};
  border: 1px solid
    ${({ theme }: { theme: Theme }) =>
      rgba(theme.palette.text.main, HANDLE_ROW_BORDER_ALPHA)};
  border-radius: 0;
  color: ${({ $isSelected, theme }: { $isSelected: boolean; theme: Theme }) =>
    $isSelected ? theme.palette.secondary.contrast : theme.palette.text.main};
  column-gap: 12px;
  display: grid;
  grid-template-columns: 1fr auto;
  justify-items: stretch;
  padding: 12px;
  text-align: left;
  width: 100%;

  & > span {
    display: none;
  }

  &:focus-visible {
    outline: 2px solid
      ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
    outline-offset: 2px;
  }

  & * {
    ${({ $isSelected, theme }: { $isSelected: boolean; theme: Theme }) =>
      $isSelected ? `color: ${theme.palette.secondary.contrast};` : ""}
  }

  p {
    margin: 0;
  }
`

export const HandleRowMain = styled.div`
  display: grid;
  row-gap: 4px;
`

export const HandleRowMeta = styled.div`
  display: grid;
  justify-items: end;
  row-gap: 4px;
`

export const Detail = styled.div`
  display: grid;
  padding: 14px;
  row-gap: 12px;

  &:focus {
    outline: 2px solid
      ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
    outline-offset: 2px;
  }
`

export const DetailHeader = styled.div`
  align-items: start;
  column-gap: 12px;
  display: grid;
  grid-template-columns: 1fr auto;
`

export const DetailTitle = styled.div`
  display: grid;
  row-gap: 4px;
`

export const DetailMeta = styled.div`
  display: grid;
  row-gap: 6px;
`

export const DetailActions = styled.div`
  display: grid;
  justify-content: start;
`
